import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import { categories } from '../data/products';
import { Link } from 'react-router-dom';
const topSellerSlugs = ['5-8-minus', '1-25-minus', '5-8-clear', '1-5-drain-rock', '2-4-quarry-rock', '3-way-topsoil', 'medium-bark'];
const topSellers = topSellerSlugs.map(slug => {
  for (const cat of categories) {
    const product = cat.products.find(p => p.slug === slug);
    if (product) return {
      ...product,
      categoryName: cat.name
    };
  }
  return null;
}).filter(Boolean) as ((typeof categories)[0]['products'][0] & {
  categoryName: string;
})[];
export function TopSellers() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  };
  const scroll = (dir: 'left' | 'right') => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = dir === 'left' ? -320 : 320;
    el.scrollBy({
      left: amount,
      behavior: 'smooth'
    });
  };
  return <section className="py-16 md:py-20 bg-[#f3f0ec] dark:bg-[#292827] transition-colors duration-300" data-id="element-1177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1178">
        <div className="flex items-end justify-between mb-8 md:mb-10" data-id="element-1179">
          <div data-id="element-1180">
            <p className="text-brand-orange font-bold text-sm tracking-[0.15em] uppercase mb-2" data-id="element-1181">
              Most Popular
            </p>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-brand-charcoal dark:text-white" data-id="element-1182">
              Top Sellers
            </h2>
          </div>
          <div className="hidden sm:flex items-center gap-2" data-id="element-1183">
            <button onClick={() => scroll('left')} disabled={!canScrollLeft} className="p-2 border border-stone-300 dark:border-stone-600 text-brand-charcoal dark:text-white hover:border-brand-orange hover:text-brand-orange disabled:opacity-30 disabled:cursor-not-allowed transition-colors" data-id="element-1184">
              <ChevronLeft className="w-5 h-5" data-id="element-1185" />
            </button>
            <button onClick={() => scroll('right')} disabled={!canScrollRight} className="p-2 border border-stone-300 dark:border-stone-600 text-brand-charcoal dark:text-white hover:border-brand-orange hover:text-brand-orange disabled:opacity-30 disabled:cursor-not-allowed transition-colors" data-id="element-1186">
              <ChevronRight className="w-5 h-5" data-id="element-1187" />
            </button>
          </div>
        </div>

        <div ref={scrollRef} onScroll={checkScroll} className="flex gap-4 overflow-x-auto scrollbar-hide pb-4 -mx-4 px-4 snap-x snap-mandatory" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-1188">
          {topSellers.map((product, idx) => <motion.div key={product.slug} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05,
          duration: 0.4
        }} className="flex-shrink-0 w-[260px] sm:w-[280px] snap-start" data-id="element-1189">
              <Link to={`/shop/${product.slug}`} className="group block bg-white dark:bg-[#1e1e1e] border border-stone-200 dark:border-[#333] hover:border-brand-orange/50 dark:hover:border-brand-orange/40 transition-all duration-300 overflow-hidden shadow-sm hover:shadow-lg" data-id="element-1190">
                <div className="relative h-44 overflow-hidden" data-id="element-1191">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-1192" />
                  <div className="absolute top-3 left-3" data-id="element-1193">
                    <span className="bg-brand-orange text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1" data-id="element-1194">
                      Top Seller
                    </span>
                  </div>
                </div>
                <div className="p-4" data-id="element-1195">
                  <p className="text-[10px] text-brand-muted dark:text-stone-500 uppercase tracking-wider font-bold mb-1" data-id="element-1196">
                    {product.categoryName}
                  </p>
                  <h3 className="font-heading font-bold text-brand-charcoal dark:text-white text-base mb-2 group-hover:text-brand-orange transition-colors" data-id="element-1197">
                    {product.name}
                  </h3>
                  <div className="flex items-center justify-between" data-id="element-1198">
                    <span className="text-lg font-bold text-brand-charcoal dark:text-white" data-id="element-1199">
                      ${product.pricePerYard}
                      <span className="text-sm font-normal text-brand-muted dark:text-stone-500" data-id="element-1200">
                        /yd
                      </span>
                    </span>
                    <span className="flex items-center gap-1 text-brand-orange text-sm font-bold opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1201">
                      View
                      <ArrowRight className="w-3.5 h-3.5" data-id="element-1202" />
                    </span>
                  </div>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </div>
    </section>;
}